export interface BlogPost {
  id: string;
  title: string;
  date: string; // ISO date
  tags: string[];
  excerpt: string;
  /** Optional: inline text, or URL to a local file (e.g. /blog-content/post.txt) to load as content. Not used when externalUrl is set. */
  content?: string;
  /** Optional emoji shown as post icon on list and home widget */
  emoji?: string;
  /** Optional icon name; e.g. 'terraform' shows Terraform logo in brand purple instead of emoji */
  icon?: string;
  /** When set, the post links to this URL (external) instead of the internal /blog/:id page. Opens in new tab. */
  externalUrl?: string;
}

/** True if content value is a URL (absolute or relative) to fetch rather than inline text */
export function isContentUrl(content: string | undefined): boolean {
  if (!content || typeof content !== 'string') return false;
  const t = content.trim();
  return t.startsWith('http://') || t.startsWith('https://') || t.startsWith('/');
}
